// list of object types
export const ENTITY = 'ENTITY';
export const ASSET = 'ASSET';
export const DOCUMENT = 'DOCUMENT';
export const HOWTO = 'HOWTO';
export const TASK = 'TASK';
export const NOTE = 'NOTE';
export const EVENT = 'EVENT';
export const PHOTO = 'PHOTO';

export const CONTAINER = 'CONTAINER';
export const QMFOLDER = 'QMFOLDER';
export const QMLIST = 'QMLIST';
export const QMLISTSUGGESTION = 'QMLISTSUGGESTION';
export const BUSINESSLIST = 'BUSINESSLIST';
export const TASKLIST = 'TASKLIST';
export const ALBUM = 'ALBUM';
export const PROJECT = 'PROJECT';
export const ROOM = 'ROOM';

export const CONNECTION = 'CONNECTION';
export const USER = 'USER';
export const BUSINESS = 'BUSINESS';
export const PRO = 'PRO';
export const SPOT = 'SPOT';
export const SUPPLIER = 'SUPPLIER';
export const CONTACT = 'CONTACT';
export const FRIEND = 'FRIEND';
export const HOUSEHOLD = 'HOUSEHOLD';

export const COMPONENTCATEGORY = 'COMPONENTCATEGORY';
export const BUSINESSCHECKIN = 'BUSINESSCHECKIN';
export const EVENTCHECKIN = 'EVENTCHECKIN';

export const MESSAGE = 'MESSAGE';

export const PENDING = 'PENDING';
export const SUBMITTED = 'SUBMITTED';
export const COMPLETED = 'COMPLETED';
export const COMPLETED_AND_EDITED = 'COMPLETED_AND_EDITED';
export const REJECTED = 'REJECTED';
export const NONE = 'NONE';

export const PROPERTY = 'PROPERTY';

export const FLIPCARD = 'FLIPCARD';
export const ID = 'ID';
export const REWARD = 'REWARD';
export const PRODUCT = 'PRODUCT';
export const INFO = 'INFO';

export const ISO = 'ISO';
export const ISO_REPLY = 'ISO_REPLY';

export const GAP = 'GAP';
export const FEED_ITEM = 'FEED_ITEM';
export const DISPLAYCARD = 'DISPLAYCARD';

export const RECEIPT = 'RECEIPT';
export const INVOICE = 'INVOICE';
export const BILL = 'BILL';
export const MANUAL = 'MANUAL';
